import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { useNotificationCount } from '../../../context/NotificationCountContext';
import { removeProjectLocation } from '../../../models/ProjectModel';


const DeleteProjectLocationModal = ({showModal, setShowModal, project_unique_id, locationData, modalKey, fetchProjectLocations, limit, page}) => {

  const { notificationCount, setNotificationCount } = useNotificationCount();

  const navigate = useNavigate();

    const { state } = useAuth(); 

    let user_data = state.user_data;
    
    const loader = document.getElementById('loading');

    const [loading, setLoading] = useState(false);
    
    const [_location_id, setLocationId] = useState('');

    const closeModal = () =>{
        setLocationId('');
        setShowModal(false);
    }

    useEffect(() => {
        // This effect will be called whenever noteData changes
        if (locationData) {
            setLocationId(locationData._location_id);
        }
    }, [project_unique_id, locationData, modalKey]);


    const deleteProjectLocation = async() => {
        // Start the loading state
        loader.style.display = 'block';
    
        try {
          const response = await removeProjectLocation(user_data.user_token, project_unique_id, _location_id);
    
          if (response.status) {
            toast.success(response.message);
    
            closeModal();
    
            fetchProjectLocations(limit, page);

            setNotificationCount(localStorage.getItem('unread_notification_count'));
          }
          else{
            toast.error(response.message);
          }  
    
        } catch (error) {
          apiError(error);

          if (error.response.data.invalid_token==1) {
            navigate('/re-login');
          }
        }
    
        // Stop the loading state
        loader.style.display = 'none';
    }

    return (
        <Modal show={showModal} onHide={closeModal}>
            <Modal.Header closeButton>
                <Modal.Title>Remove Location</Modal.Title>
            </Modal.Header>
    
            <Modal.Body>
                <p>Do you want to remove this location from this project ?</p>
            </Modal.Body>
    
            <Modal.Footer>
                <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={deleteProjectLocation}>Delete</button>
            </Modal.Footer>
        </Modal>
    );  

}; 


export default DeleteProjectLocationModal;